import script from "./AddUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUserModal.vue?vue&type=style&index=0&id=3bfd6c53&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bfd6c53"]])

export default __exports__